import React, { useState } from "react";
import { Button } from "primereact/button";
import { Chart } from "primereact/chart";
import { Divider } from "primereact/divider";

const SurveyXmotTypeChart = React.memo(function SurveyXmotTypeChart({
  sessionQuesData,
  chartOptions,
  index,
  handleSelectedSaveBtnIndex,
  selectedSaveBtnIndex,
}) {
  const { chartData } = sessionQuesData;

  return (
    <div>
      {/* CHART SECTION */}
      <Chart
        className="mb-3"
        type="bar"
        data={chartData?.length ? chartData[0] : []}
        options={chartOptions}
      />

      <Divider />
    </div>
  );
});

export default SurveyXmotTypeChart;
